import { Link } from 'react-router-dom';
import { Mail, MessageCircle, Phone } from 'lucide-react';
import { useLang } from '../i18n';
import { useSEO } from '../seo';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { waConfigured, waLink } from '../config/whatsapp';

export default function ContactPage() {
  const { t } = useLang();
  useSEO(`${t('contact.title')} | Eco Collection`, t('contact.sub'));

  return (
    <div data-testid="contact-page">
      <PageHeader kicker="Eco Collection" title={t('contact.title')} sub={t('contact.sub')} />
      <section className="bg-eco-cream py-14">
        <div className="mx-auto max-w-2xl px-5 space-y-4">
          <Reveal>
            <a href="tel:+4917684450554" data-testid="contact-phone" className="flex items-center gap-4 rounded-2xl border border-eco-ink/10 bg-white p-6 transition-colors hover:border-eco-gold/50">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-eco-green text-eco-gold"><Phone size={18} /></span>
              <span>
                <span className="eco-field-label block">{t('contact.call')}</span>
                <span className="eco-number mt-1 block text-lg font-bold text-eco-ink">+49 176 844 50554</span>
              </span>
            </a>
          </Reveal>
          <Reveal>
            <a href="mailto:Admin@bsgotech.com" data-testid="contact-email" className="flex items-center gap-4 rounded-2xl border border-eco-ink/10 bg-white p-6 transition-colors hover:border-eco-gold/50">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-eco-green text-eco-gold"><Mail size={18} /></span>
              <span>
                <span className="eco-field-label block">{t('contact.mail')}</span>
                <span className="mt-1 block text-lg font-bold break-all text-eco-ink">Admin@bsgotech.com</span>
              </span>
            </a>
          </Reveal>
          {waConfigured && (
            <Reveal>
              <a href={waLink(t('wa.general'))} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp" className="flex items-center gap-4 rounded-2xl border border-eco-ink/10 bg-white p-6 transition-colors hover:border-eco-gold/50">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#25D366] text-white"><MessageCircle size={18} /></span>
                <span>
                  <span className="eco-field-label block">WhatsApp</span>
                  <span className="mt-1 block text-sm font-medium text-eco-ink/70">{t('contact.wa')}</span>
                </span>
              </a>
            </Reveal>
          )}
          <Reveal>
            <div className="rounded-2xl bg-eco-deep p-6 text-center">
              <p className="text-sm text-white/70">{t('contact.plan.sub')}</p>
              <Link to="/plan-my-trip" data-testid="contact-plan-cta" className="eco-btn-primary mt-4 inline-flex">{t('contact.plan.cta')}</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
